module.exports = __webpack_public_path__ + "img/DSC_0180 teatro criss_thumb.3ce04e28.jpg";